<template>
  <div v-loading="loading" class="alarmClass">
    <div>
      <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="105px">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="商品名" prop="name">
              <el-input
                clearable
                v-model="form.name"
                placeholder="请输入商品名"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="图片" prop="icon">
              <el-upload 
              :headers="headers" 
              class="avatar-uploader" 
              action="/api/v4ward/oss/customEndpoint/put-file" 
              :before-upload="beforeupload"  
              :show-file-list="false" 
              :on-success="handleUpSuccess">
              <el-image 
              v-if="form.icon" 
              :src="form.icon" 
              class="avatar">
            </el-image>
              <i v-else class="el-icon-plus avatar-uploader-icon " style="width:200px;height:200px;"></i>
            </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="商品介绍" prop="introduce">
              <el-input
                style="width: 100%"
                v-model="form.introduce"
                type="textarea"
                placeholder="请填写商品介绍"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="text-align: right" v-if="model != 'view'">
      <el-button type="primary" icon="el-icon-circle-plus-outline" @click="saveRecord" size="small">
        保存
      </el-button>
      <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small"> 取消 </el-button>
    </div>
  </div>
</template>
    <script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
} from '@/api/v4ward/offline/merchant/goods/offlinemerchantgoods';
import vUpload from './mutil-upload.vue';
import { getToken } from '@/util/auth';
import settings from '@/config/vd-settings';
export default {
  components: {
    vUpload,
  },
  props: {
    id:'',
    row: {
      default: {},
    },
    model: {
      default: 'add',
    },
  },
  data() {
    return {
      form: {
        icon:"",
        name: '',
        introduce: '',
        attachList: [],
      },
      formRules: {
        name: [{ required: true, message: '商品名不能为空', trigger: 'change' }],
        introduce: [{ required: true, message: '商品介绍不能为空', trigger: 'change' }],
        attachList: [{ required: true, message: '商品图片不能为空', trigger: 'change' }],
      },
      headers:{}
    };
  },
  created() {
    this.headers['Authorization'] = `Basic ${Base64.encode(
        `${settings.clientId}:${settings.clientSecret}`
      )}`;

        // 让每个请求携带token--['Authorization']为自定义key 请根据实际情况自行修改
        this.headers['Blade-Auth'] = 'bearer ' + getToken();
    this.initData();
  },
  mounted() {},
  watch: {},
  methods: {
    initData() {
      if (this.model === 'add') {
      } else {
        this.form = Object.assign({}, this.row);
      }
      this.form.merchantId = this.id
    },
      //上传之前
      beforeupload(file) {
        const isJPG = file.type == 'image/jpeg'|| file.type === 'image/png';
        const isLt2M = file.size / 1024 / 1024 < 12;

        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG,PNG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 12MB!');
        }
        return isJPG && isLt2M;
      },
        //图片上传成功
        handleUpSuccess(response) {
        console.log(response)
        this.form.icon = response.data.link;
      },
    saveRecord() {
      this.$refs['formRef'].validate((valid) => {
        if (valid) {
          if (this.model === 'add') {
            add(this.form).then(
              () => {
                this.$emit('submit');
                this.$message.success('添加成功!');
                
              },
              (error) => {
                window.console.log(error);
                loading();
              }
            );
          } else {
            this.row.name = this.form.name;
            this.row.icon = this.form.icon;
            this.row.introduce = this.form.introduce;
            this.$emit('cancle');
            update(this.form).then(() => {
                    this.$message.success('修改成功!');
                    
                }, error => {
                    window.console.log(error);
                    loading();
                });
          }
        }
      });
    },
    cancleRecord() {
      this.$emit('cancle');
    },
  },
};
</script>
    <style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
::v-deep .el-col-8 {
  height: 54px;
}
</style>
    